import {
  Box,
  Grid,
  Divider,
  Stack,
  TextField,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import "../Styles/AdminFacility.css";
import { Link, useParams } from "react-router-dom";
import EmailInputField from "../../common/EmailInputField";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getCareFacilityList,
  createClientUser,
  updateClientUser
} from "../../common/constants/globalconstants";
import { updateActiveCounts } from "../../../action";
import { useLocation, useNavigate } from "react-router-dom";
import { Check, Error } from "@mui/icons-material";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
import CareFacilityTreeSelect from "./CareFacilityTreeSelect";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

function NewClientUser() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { action } = useParams();
  const [facilityRecords, setFacilityRecords] = useState([]);
  const [accountNum, setAccountNum] = useState("");
  const [careFacility, setCareFacility] = useState("");
  const [careFacilityId, setCareFacilityId] = useState("");
  const [careFacilityErr, setCareFacilityErr] = useState("");
  const storeUser = useSelector((state) => state.storeuser);
  const [loading, setloading] = useState(false);
  const [error, setError] = useState({});
  const [careFacilityEmail, setCareFacilityEmail] = useState("");
  const [emailError, setEmailError] = useState({});
  const [open, setOpen] = useState(false);
  const [errormodalopen, seterrormodalOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedIds, setSelectedIds]= useState([]);
  const [initiallySelectedIds, setInitiallySelectedIds] = useState([]);
  const [facilityData, setFacilityData] = useState({
    id: "",
    firstName:"",
    lastName: "",
    userName:""
  });
  const [userName, setUserName] = useState("");
  const [searchText, setSearchText] = useState("");
  const [fieldHeight, setFieldHeight] = useState("65px");
  const [firstNameHeight, setFirstNameHeight] = useState("65px");
  const [lastNameHeight, setLastNameHeight] = useState("65px");

  useEffect(() => {
    fetchCarefacilityList();  
  }, [location]);

  const fetchCarefacilityList = async()=>{
    try{
    setloading(true);
    const resp = await axiosInstance.get(`${getCareFacilityList}`);
      if(resp.data.isSuccess){
      //success fetching data 
      const filteredList = (resp.data.result.careFacilityList).filter(item => item.isStandAlone === "YES" || item.isChild === "YES")
      setFacilityRecords(filteredList);
      setCareFacility(location.state.careFacility);
      setAccountNum(location.state.accountNum);
      setCareFacilityId(location.state.id);
      setCareFacilityEmail(resp.data.result.careFacilityList[0].email);
      const { numberofActiveUsers, numberofCareFaclities } = resp.data.result;
      dispatch(
        updateActiveCounts({ numberofActiveUsers, numberofCareFaclities })
      );
    }
    else if(!resp.data.isSuccess){
      seterrormodalOpen(true);
    }
      setloading(false);
    }
    catch(err) {
      setloading(false);
      seterrormodalOpen(true);
      console.log(err.message)
    }
}

  useEffect(() => {
    const selectedFacility = facilityRecords.find(
      (item) => item.companyName === location.state.careFacility
    );
    populateFacilityDetails(selectedFacility);
  }, [facilityRecords]);

  const populateFacilityDetails = (selectedFacility) => {
    if (selectedFacility != undefined) {
      setFacilityData({
        ...facilityData,
        id: selectedFacility.id,
        zip: selectedFacility.zip,
        state: selectedFacility.state,
        city: selectedFacility.city,
        address: selectedFacility.address,
        phone: selectedFacility.telephoneNum,
        contactPerson: selectedFacility.contactPerson,
        email: selectedFacility.email,
      });
    }
  };

  useEffect(() =>{
    if(action == "edit"){
      setUserName(location.state.userName);
      setFacilityData({...facilityData,
        id : location.state.id,
        firstName : location.state.firstName,
        lastName : location.state.lastName,
        userName : location.state.userName
      })
      getCareFacilityIdsByName(location.state.careFacilities);
    }
  },[facilityRecords])

  const getCareFacilityIdsByName =(careFacilities) =>{
    const cfList = careFacilities.split(";");
    const enhancedList = cfList.map((value)=> value.split(" -")[0].trim().toLowerCase());
    const listOfIds = enhancedList.map((item) => item.split(":")[1]);
    const idsList= facilityRecords.filter(record => 
      listOfIds.includes(record.id))
      .map(record => record.id);
    setInitiallySelectedIds(idsList);
    return idsList;
  }

  const changeHandler = (e) => {
    e.preventDefault();
    if(e.target.name == "userName"){
        setUserName(e.target.value);
        setFacilityData({...facilityData, userName: e.target.value});
      if(e.target.value !== ""){
        setError({...error, userName:""})
        setError({...error, email:""})
      }

      if(e.target.value === "" || e.target.value === undefined || e.target.value === null){
        setError({...error, email: "This field cannot be blank" })
      }
    }
     if(e.target.name == "firstName"){
      setFacilityData({...facilityData, firstName: e.target.value});
      
      if(e.target.value !== ""){
      setError({...error, firstName:""})
      }

      if(e.target.value === "" || e.target.value === undefined || e.target.value === null){
        setError({...error, firstName: "This field cannot be blank" })
      }
    }
     if(e.target.name == "lastName"){  
      setFacilityData({...facilityData, lastName: e.target.value});
      if(e.target.value !== ""){
      setError({...error, lastName:""})
      }

      if(e.target.value === "" || e.target.value === undefined || e.target.value === null){
        setError({...error, lastName: "This field cannot be blank" })
      }
    }
  };

  const handleEmailError = (emailError) => {
    if (emailError) {
      setEmailError({ email: emailError });
    } else {
      setEmailError({});
    }
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(facilityData).forEach((key) => {
      if (key !== "id" && !facilityData[key]) {
        newErrors[key] = "This field cannot be blank";
        setFieldHeight("74px");
        setFirstNameHeight("74px");
        setLastNameHeight("74px");
      }
    });
    setError(newErrors);

     if (facilityData.userName === "") {
      newErrors["email"] = "This field cannot be blank";
     }else{
      setError({});
     }

    if(selectedIds.length === 0){
      newErrors["carefacility"] = "Please select at least 1 Care facility";
      setError(newErrors);
    }else{
      //newErrors["carefacility"] = "";
      setError({});
    }

    setError(newErrors);
    
    return (
      Object.keys(newErrors).length === 0 &&
      Object.keys(emailError).length === 0 && careFacilityErr === ""
    );
  };

  const handleOnSubmit = async() => {
    try {
      let response;
      if (validateForm()) {
        const clientUserData = {
          id: action ==="edit" ? facilityData.id : 0,
          userName: facilityData.userName,
          updatedBy: storeUser.email,
          firstName: facilityData.firstName,
          lastName: facilityData.lastName,
          careFacilityIdList: selectedIds
        };
       if(action === "edit") {
        response = await axiosInstance.post(`${updateClientUser}`,
          JSON.stringify(clientUserData));
        }else{
          response = await axiosInstance.post(`${createClientUser}`,
            JSON.stringify(clientUserData));
        }
            if (response.data.isSuccess) {
              setSuccess(true);
              setErrorFlag(false);
            } else {
              setErrorMsg(response.data.Message);
              setErrorFlag(true);
              setSuccess(false);
              
            }
            setOpen(true);
      }
    } catch (error) {
      console.log(error);
      seterrormodalOpen(true);
    }
  };


  const handleClose = () => {
    setOpen(false);
    navigate("/admin/careUserListings/viewAll");
  };

  const resetForm = () => {
    if(action !== "edit"){
      setUserName("");
      setFacilityData({
        id:"",
        firstName:"",
        lastName:"",
        userName:""
      });
    }
    else{
    setFacilityData({
      ...facilityData,
      firstName:"",
      lastName:"",
    });
    }    
    setSelectedIds([]);
    setError({});
    setEmailError({});
    setSearchText("");
  }

  return (
    <Box
      sx={{
        position: "relative",
        left: "2.8%",
        flexDirection: "column",
        width: "90%",
        marginTop: "20px",
        alignItems: "center",
        p: "0% 2%",
        backgroundColor: "#fcfcfc",
        border: "2px solid #dfe3e8",
        borderRadius: "20px",
      }}
    >
      {/* <ActiveCounts /> */}
      <h2 className="header">{action === "edit" ? "Update Client User" : "Create Client User"}</h2>
      <Divider
        variant="fullwidth"
        sx={{ backgroundColor: "#dfe3e8" }}
      ></Divider>
      <br></br>
      <Grid xs={12}>
        <Grid container xs={12} spacing={0}>
        <Grid xs={6}
              item
              sx={{
                p: "5px 5px",
                border: "1.5px solid #dfe3e8",
                borderRadius: "5px",
                backgroundColor: "white",
              }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${fieldHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                  width:"100%"
                }}
              >
                <p className="input-label">
                  Username <span id="req-field">*</span>
                </p>
                <EmailInputField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="User Name"
                  name="userName"
                  required
                  value={facilityData.userName}
                  onEmailError={handleEmailError}
                  error={emailError.email || error.email}
                  helperText={emailError.email ? emailError.email : error.email}
                  onChange={changeHandler}
                  inputProps={{readOnly: action == "edit" ? true : false, maxLength: 500}}
                  sx={{ width: "250px", float:"left" }}
                  InputProps={{
                    className: action == "edit" ? "Mui-disabled" : undefined,
                  }}
                />
              </Box>
            </Stack>

            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>


             <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${firstNameHeight}`, m: "5px 0" }}
              gap="1rem"
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                  width:"100%"
                }}
              >
                <p className="input-label">First Name<span id="req-field">*</span>

                </p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="First Name"
                  name="firstName"
                  //inputProps={{ readOnly: true }}
                  value={facilityData.firstName}
                  onChange={changeHandler}
                  error={error.firstName || ""}
                  helperText={error.firstName ? error.firstName : ""}
                  sx={{width: "250px", float:"left"}}
                />
              </Box>
              
              
            </Stack>

            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${lastNameHeight}`, m: "5px 0" }}
              gap="1rem"
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "left",
                  width:"100%"
                }}
              >
                <p className="input-label">Last Name<span id="req-field">*</span>

                </p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  placeholder="Last Name"
                  name="lastName"
                  //inputProps={{ readOnly: true }}
                  value={facilityData.lastName}
                  onChange={changeHandler}
                  error={error.lastName || ""}
                  helperText={error.lastName ? error.lastName : ""}
                  sx={{width: "250px", float:"left"}}
                />
              </Box>
              
            </Stack>
            
        </Grid>
        <Grid xs={6}
              item
              sx={{
                p: "5px 5px",
                border: "1.5px solid #dfe3e8",
                borderRadius: "5px",
                backgroundColor: "white",
              }}>
                <CareFacilityTreeSelect
                selectedIds={selectedIds}
                setSelectedIds= {setSelectedIds}
                searchText={searchText}
                setSearchText={setSearchText}
                setError= {setError}
                error={error}
                initiallySelectedIds={initiallySelectedIds}/>
        </Grid> 
          
        </Grid>
          <br></br>
  
          <Grid
            item
            xs={12}
            sx={{
              mt: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box>
            <Button
                    id="psa-cf-rst-btn"
                    onClick={resetForm}
                    variant="outlined"
                    sx={{ width: "120px" }}
                  >
                    Reset
              </Button>
            <Link to="/admin/careUserListings">
              <Button variant="outlined" id="user-back-btn">
                Back
              </Button>
            </Link>            
            </Box>
            <Button
              id="user-submit-btn"
              variant="contained"
              onClick={handleOnSubmit}
            >
              Submit
            </Button>
          </Grid>
      </Grid>
      <Modal open={open} onClose={() => setOpen(false)}>
        <>
          {success && (
            <Box sx={style}>
              <IconButton sx={{ border: "2px solid green", boxShadow: "none" }}>
                <Check sx={{ color: "green" }} />
              </IconButton>
              {action !== "edit" ? 
              <p>User {userName} created successfully!</p>
              : <p>User {userName} updated successfully!</p>}
              <Button
                id="modal-close-btn"
                variant="contained"
                onClick={handleClose}
              >
                Close
              </Button>
            </Box>
          )}
          {errorFlag && (
            <Box sx={style}>
              <IconButton sx={{ border: "2px solid red", boxShadow: "none" }}>
                <Error sx={{ color: "red" }} />
              </IconButton>
              <p> {errorMsg} </p>
              <Button
                id="modal-close-btn"
                variant="contained"
                onClick={() => setOpen(false)}
              >
                Close
              </Button>
            </Box>
          )}
        </>
      </Modal>
      {errormodalopen && (
            <ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
          )}
    </Box>
  );
}

export default NewClientUser;
